import { RootState } from "@/store/store";
import { infrastructureArchitectureRequestDataSelector } from "@/store/infrastructure-architecture/selectors/infrastructureArchitectureRequestDataSelector";

export const infrastructureArchitectureSelectedAccountSelector = (
  state: RootState,
) => {
  return infrastructureArchitectureRequestDataSelector(state)
    ?.selectedAccountId;
};
